module.exports = __webpack_public_path__ + "img/user_name_icon.6f119063.svg";